export default "__VITE_ASSET__DvFEY2Bp__"